/*
  Rituaalide sissejuhatuse video (03.09.2026, teine ring).

  MIKS JS-I ÜLDSE ON VAJA. Video mängib ise, aga `autoplay` atribuuti ei ole
  märgendis ja `src` on `data-src` all. Põhjus on üks: `autoplay` paneb
  brauseri faili laadima kohe lehe avamisel, ka siis kui plokk on kolm
  ekraanitäit allpool. 11 MB lehe avamisel on liiga palju. IntersectionObserver
  paneb allika külge ja käivitab alles siis, kui plokk on 200 px vaateväljast.

  MIKS `muted` ON KOHUSTUSLIK. Brauserid blokivad helilise autoplay ilma
  kasutaja žestita, ja `play()` tagastaks tagasilükatud lubaduse. Failid on
  kodeeritud `-an`, seega heliriba ei ole isegi olemas.

  MIKS PAUSINUPP ON OLEMAS. WCAG 2.2.2: üle 5 sekundi automaatselt käivituv
  liikuv sisu peab olema peatatav. Video on 44 s. Ilma nuputa ei tohiks teda
  ise käivitada — see ei ole kaunistus, vaid tingimus.

  MIDA JUHTUB ILMA JS-ITA: `src`-i ei tule kunagi külge, seega kastis on
  poster ja plokk näeb välja nagu fotoga variant. Ükski lubadus ei jää
  täitmata — nupp on ainus asi, mis üleliigsena alles jääks, ja seepärast
  peidab CSS ta ära, kuni JS on ta üles leidnud (`is-live`).
*/
(function () {
  var MOBIIL = 749;

  function seo(raam) {
    var video = raam.querySelector('video');
    var nupp = raam.querySelector('[data-rit-toggle]');
    if (!video) return;

    var laetud = false;
    var kasutajaPeatas = false;

    function laadi() {
      if (laetud) return;
      laetud = true;
      var src = video.getAttribute('data-src');
      var mob = video.getAttribute('data-src-mobile');
      if (mob && window.matchMedia('(max-width: ' + MOBIIL + 'px)').matches) src = mob;
      if (!src) return;
      /* `muted` seatakse ka JS-ist, mitte ainult atribuudina: Chrome nõuab
         autoplay lubamiseks, et OMADUS oleks tõene enne `play()`-d, ja
         dünaamiliselt seatud allika juures ei ole atribuut alati jõudnud
         omaduseks saada. */
      video.muted = true;
      video.src = src;
      /* `load()` EI OLE siin — ta lähtestab meediaelemendi ja katkestab juba
         käivitatud `play()` päringu („The play() request was interrupted by a
         new load request"). Mõõdetud 03.09.2026: selle reaga jäi video
         `paused: true` ja nupp läks kohe „esita" olekusse. `src` seadmine
         käivitab laadimise niikuinii. */
    }

    function mangi() {
      if (kasutajaPeatas) return;
      laadi();
      var lubadus = video.play();
      if (lubadus && typeof lubadus.catch === 'function') {
        lubadus.catch(function () {
          /* Käivitamine ei õnnestunud (nt energiasäästurežiim). Poster jääb
             ette ja nupp lubab käsitsi proovida. */
          seaNupp(true);
        });
      }
    }

    function seaNupp(peatatud) {
      if (!nupp) return;
      nupp.setAttribute('aria-pressed', peatatud ? 'true' : 'false');
      nupp.setAttribute('aria-label', peatatud ? 'Esita video' : 'Peata video');
    }

    if (nupp) {
      raam.classList.add('is-live');
      nupp.addEventListener('click', function () {
        if (video.paused) {
          kasutajaPeatas = false;
          laadi();
          video.play();
          seaNupp(false);
        } else {
          kasutajaPeatas = true;
          video.pause();
          seaNupp(true);
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      mangi();
      return;
    }

    var vaatleja = new IntersectionObserver(
      function (kirjed) {
        kirjed.forEach(function (k) {
          if (k.isIntersecting) {
            mangi();
          } else if (!video.paused) {
            /* Vaateväljast väljas ei ole mõtet dekodeerida. Kasutaja enda
               pausi see ei tühista — `kasutajaPeatas` jääb kehtima. */
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    vaatleja.observe(raam);
  }

  function alusta() {
    var raamid = document.querySelectorAll('[data-rit-video]');
    for (var i = 0; i < raamid.length; i++) seo(raamid[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alusta);
  } else {
    alusta();
  }
})();
